<!-- 忘记密码第一步 -->
<template>
  <div id="forget-pwd">
    <div class="forget-pwd"
         @keydown.enter="nextHandle">
      <div class="logo">
        <img :src="logo"
             alt="">
      </div>
      <p>MSP学生服务平台 - 重置密码</p>
      <Form ref="formValidate"
            :model="formValidate"
            :rules="ruleValidate">
        <FormItem label=""
                  prop="name">
          <Input v-model.trim="formValidate.name"
                 placeholder="用户名"
                 clearable></Input>
        </FormItem>
        <FormItem label=""
                  prop="code">
          <Input v-model.trim="formValidate.code"
                 placeholder="验证码"
                 class="forget-pwd-code"></Input>
          <span class="forget-pwd-getcode"
                :class="[num!=-1?'forget-pwd-disabled':'']"
                @click="getCode">{{num===-1?'获取验证码': num+'秒'}}</span>
        </FormItem>
      </Form>
      <div class="return-login">
        <a @click="logoHandle">返回登录</a>
      </div>
      <div class="forget-pwd-btn">
        <Button class="zlr-btn-primary"
                @click="nextHandle"
                :loading="isSub">下一步</Button>
      </div>
    </div>
    <Bottom></Bottom>
    <canvas id="canvas"></canvas>
  </div>
</template>

<script>
// api
import { codeReset, codeCheck } from '@/api/personal'
// less
import './index.less'
// mixins
import bgColor from '@/view/mixins/bg-color'
// images
import logo from '@/assets/Logo.svg'
import wave from './wave.js'
import Bottom from './intro-bottom'
export default {
  name: 'forget-pwd1',
  components: {
    Bottom
  },
  mixins: [bgColor],
  data () {
    return {
      logo,
      formValidate: {},
      ruleValidate: {
        name: [{ required: true, message: '用户名不能为空' }],
        code: [{ required: true, message: '验证码不能为空' }]
      },
      num: -1,
      inetrvalTime: '',
      isSub: false
    }
  },
  computed: {},
  mounted () {
    wave()
  },
  methods: {
    getCode () {
      let name = this.formValidate.name
      if (!name) {
        this.$zlr_message('用户名不能为空', 'error')
        return false
      }
      // 发送验证码
      codeReset({
        num: name
      }).catch(error => {
        clearInterval(this.inetrvalTime)
        this.num = -1
        this.$zlr_message(error.message, 'error')
      })
      this.num = 60
      this.inetrvalTime = setInterval(() => {
        this.num--
        if (this.num < 0) {
          clearInterval(this.inetrvalTime)
        }
      }, 1000)
    },
    nextHandle () {
      if (this.isSub) return false
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          this.isSub = true
          let data = {
            loginId: this.formValidate.name,
            code: this.formValidate.code
          }
          codeCheck(data).then(res => {
            if (res.data.model) {
              this.$router.push({
                name: 'modify',
                params: {
                  name: data.loginId,
                  code: data.code
                }
              })
            } else {
              this.$zlr_message('验证码错误或已过期', 'error')
            }
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          }).then(() => {
            this.isSub = false
          })
        }
      })
    },
    // 返回登录
    logoHandle () {
      this.$router.push({
        name: 'login'
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.inetrvalTime)
  }
}
</script>
<style lang='less' scoped>
</style>
